import { useEffect, useMemo } from 'react';
import { lockBodyScroll, unlockBodyScroll } from '../../../../../helpers/bodyScrollLock';
import mediaQuery from '../../../../../helpers/mediaQuery';

function useBodyScrollLock(canDisplayDropdown: boolean, innerWidth: number): void {
  const isXLargeUp = useMemo(() => mediaQuery.isXLargeUp(), [innerWidth]);

  const toggleBodyScrollLock = () => {
    if (canDisplayDropdown && !isXLargeUp) {
      lockBodyScroll();
    }
    return () => {
      unlockBodyScroll();
    };
  };

  useEffect(toggleBodyScrollLock, [isXLargeUp, canDisplayDropdown]);
}

export default useBodyScrollLock;
